export enum QuestionOptions {
    A,
    B,
    C,
    D
}

export function QuestionOptionTypeString(option: QuestionOptions) {
    switch (option) {
        case QuestionOptions.A:
            return "اول";
        case QuestionOptions.B:
            return "دوم";
        case QuestionOptions.C:
            return "سوم";
        case QuestionOptions.D:
            return "چهارم";
    }
}